import { useInfiniteQuery, useQuery } from "@tanstack/react-query";

import { orderKeys, type OrderFilters } from "../../../data/query-keys/orders";
import { ORDER_CACHE_TIME } from "../../../data/query-client/queryClient";
import { fetchOrderDetails, fetchOrdersSnapshot } from "../api/ordersApi";

export const SNAPSHOT_RECONCILE_INTERVAL = 10 * 60 * 1000;

export function useOrders(filters: OrderFilters, enabled = true) {
  return useInfiniteQuery({
    queryKey: orderKeys.list(filters),
    queryFn: ({ pageParam }) => fetchOrdersSnapshot(filters, pageParam),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
    enabled,
    staleTime: SNAPSHOT_RECONCILE_INTERVAL,
    refetchInterval: SNAPSHOT_RECONCILE_INTERVAL,
    refetchIntervalInBackground: true,
    refetchOnReconnect: "always",
  });
}

export function useOrderDetails(orderId: number | null, enabled = true) {
  return useQuery({
    queryKey: orderKeys.detail(orderId ?? 0),
    queryFn: () => fetchOrderDetails(orderId!),
    enabled: enabled && orderId !== null,
    staleTime: Infinity,
    gcTime: ORDER_CACHE_TIME,
    // Snapshot hydration owns freshness. This endpoint is emergency fallback
    // only when an order is outside the current snapshot.
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
}
